import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import Typography from "./Typography";
import ButtonMore from "../Button/ButtonMore/ButtonMore";

import styles from "./TypographyCropped.module.scss";

const TypographyCropped = ({
  lineNumber,
  className,
  classNameButtonMore,
  style,
  html,
  defaultHTML = "",
  disableGhostHTML = false,
  ...restProps
}) => {
  const [finalStyle, setFinalStyle] = useState({ ...style });
  const [elTypography, setElTypography] = useState(null);
  const [maxHeight, setMaxHeight] = useState(0);
  const [heightWithMore, setHeightWithMore] = useState(0);
  const [isMoreActive, setIsMoreActive] = useState(false);
  const [isCropped, setIsCropped] = useState(false);

  const [text, setText] = useState(disableGhostHTML ? html : defaultHTML);

  const handleClickMore = () => {
    setIsMoreActive((v) => !v);
  };

  useEffect(() => {
    if (elTypography) {
      const style = window.getComputedStyle(elTypography);
      setHeightWithMore(parseFloat(style["line-height"]) * (lineNumber - 1));
      setMaxHeight(parseFloat(style["line-height"]) * lineNumber);
    }
  }, [elTypography, html]);

  useEffect(() => {
    setIsCropped(false);
    setIsMoreActive(false);
    setFinalStyle({ ...style });
  }, [html]);

  useEffect(() => {
    if (elTypography && maxHeight) {
      const shouldBeTruncated = elTypography.scrollHeight > maxHeight;
      setIsCropped(shouldBeTruncated);
      setText(html);

      if (shouldBeTruncated && heightWithMore) {
        const styles = { ...style };
        if (!isMoreActive) {
          styles.maxHeight = heightWithMore;
          styles.overflow = "hidden";
        }
        setFinalStyle(styles);
      }
    }
  }, [maxHeight, heightWithMore, elTypography, isMoreActive, html]);

  return (
    <>
      {!disableGhostHTML && (
        <Typography
          ref={setElTypography}
          className={classnames(className, styles["text"], "hidden-height", "typoCropParaGhostClass")}
          style={finalStyle}
          dangerouslySetInnerHTML={{
            __html: html,
          }}
          {...restProps}
        />
      )}
      <Typography
        className={classnames(className, styles["text"])}
        style={finalStyle}
        dangerouslySetInnerHTML={{
          __html: text,
        }}
        {...restProps}
      />
      <ButtonMore
        style={{
          display: isCropped || disableGhostHTML ? "block" : "none",
        }}
        data-line-number={lineNumber}
        className={classnames(styles["button-more"], classNameButtonMore)}
        isMoreActive={isMoreActive}
        onClick={handleClickMore}
      />
    </>
  );
};

TypographyCropped.propTypes = {
  heightRem: PropTypes.number,
  style: PropTypes.object,
  crop: PropTypes.bool,
};

export default TypographyCropped;
